"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { useI18n } from "./i18n-provider";
import { LOCALES, type Locale } from "@/lib/i18n";
const LABELS: Record<Locale, string> = {
  fr: "Français",
  en: "English",
  de: "Deutsch",
  it: "Italiano",
  es: "Español"
};
function Flag(t0) {
  const $ = _c(28);
  const {
    locale,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `block h-[14px] w-[21px] overflow-hidden rounded-[2px] ${className}`;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      viewBox: "0 0 30 20",
      className: t2,
      "aria-hidden": true
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const common = t3 as const;
  switch (locale) {
    case "fr":
      {
        let t4;
        let t5;
        let t6;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <rect width="10" height="20" fill="#002654" />;
          t5 = <rect x="10" width="10" height="20" fill="#fff" />;
          t6 = <rect x="20" width="10" height="20" fill="#ce1126" />;
          $[2] = t4;
          $[3] = t5;
          $[4] = t6;
        } else {
          t4 = $[2];
          t5 = $[3];
          t6 = $[4];
        }
        let t7;
        if ($[5] !== common) {
          t7 = <svg {...common}>{t4}{t5}{t6}</svg>;
          $[5] = common;
          $[6] = t7;
        } else {
          t7 = $[6];
        }
        return t7;
      }
    case "it":
      {
        let t4;
        let t5;
        let t6;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <rect width="10" height="20" fill="#009246" />;
          t5 = <rect x="10" width="10" height="20" fill="#fff" />;
          t6 = <rect x="20" width="10" height="20" fill="#ce2b37" />;
          $[7] = t4;
          $[8] = t5;
          $[9] = t6;
        } else {
          t4 = $[7];
          t5 = $[8];
          t6 = $[9];
        }
        let t7;
        if ($[10] !== common) {
          t7 = <svg {...common}>{t4}{t5}{t6}</svg>;
          $[10] = common;
          $[11] = t7;
        } else {
          t7 = $[11];
        }
        return t7;
      }
    case "de":
      {
        let t4;
        let t5;
        let t6;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <rect width="30" height="7" fill="#000" />;
          t5 = <rect y="6.66" width="30" height="7" fill="#dd0000" />;
          t6 = <rect y="13.33" width="30" height="6.67" fill="#ffce00" />;
          $[12] = t4;
          $[13] = t5;
          $[14] = t6;
        } else {
          t4 = $[12];
          t5 = $[13];
          t6 = $[14];
        }
        let t7;
        if ($[15] !== common) {
          t7 = <svg {...common}>{t4}{t5}{t6}</svg>;
          $[15] = common;
          $[16] = t7;
        } else {
          t7 = $[16];
        }
        return t7;
      }
    case "es":
      {
        let t4;
        let t5;
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <rect width="30" height="20" fill="#aa151b" />;
          t5 = <rect y="5" width="30" height="10" fill="#f1bf00" />;
          $[17] = t4;
          $[18] = t5;
        } else {
          t4 = $[17];
          t5 = $[18];
        }
        let t6;
        if ($[19] !== common) {
          t6 = <svg {...common}>{t4}{t5}</svg>;
          $[19] = common;
          $[20] = t6;
        } else {
          t6 = $[20];
        }
        return t6;
      }
    case "en":
      {
        let t4;
        let t5;
        let t6;
        let t7;
        let t8;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <rect width="60" height="40" fill="#012169" />;
          t5 = <path d="M0,0 60,40M60,0 0,40" stroke="#fff" strokeWidth="8" />;
          t6 = <path d="M0,0 60,40M60,0 0,40" stroke="#c8102e" strokeWidth="3" />;
          t7 = <path d="M30,0V40M0,20H60" stroke="#fff" strokeWidth="12" />;
          t8 = <path d="M30,0V40M0,20H60" stroke="#c8102e" strokeWidth="7" />;
          $[21] = t4;
          $[22] = t5;
          $[23] = t6;
          $[24] = t7;
          $[25] = t8;
        } else {
          t4 = $[21];
          t5 = $[22];
          t6 = $[23];
          t7 = $[24];
          t8 = $[25];
        }
        let t9;
        if ($[26] !== common) {
          t9 = <svg {...common} viewBox="0 0 60 40" preserveAspectRatio="none">{t4}{t5}{t6}{t7}{t8}</svg>;
          $[26] = common;
          $[27] = t9;
        } else {
          t9 = $[27];
        }
        return t9;
      }
  }
}
export default function LanguageSwitch(t0) {
  const $ = _c(29);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const {
    locale,
    setLocale
  } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  let t2;
  let t3;
  if ($[0] !== open) {
    t2 = () => {
      if (!open) {
        return;
      }
      const close = event => {
        if (event instanceof KeyboardEvent ? event.key === "Escape" : !ref.current?.contains(event.target as Node)) {
          setOpen(false);
        }
      };
      document.addEventListener("mousedown", close);
      document.addEventListener("keydown", close);
      return () => {
        document.removeEventListener("mousedown", close);
        document.removeEventListener("keydown", close);
      };
    };
    t3 = [open];
    $[0] = open;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const t4 = `relative ${className}`;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fontFamily: "var(--cp-font-anton)"
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpen(_temp);
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = `Langue : ${LABELS[locale]}`;
  const t8 = `group flex items-center gap-2 border px-2.5 py-1.5 text-[12px] uppercase tracking-[0.2em] transition-colors duration-200 ${open ? "border-[#e8620a]/60 text-white" : "border-white/15 text-white/70 hover:border-[#e8620a]/50 hover:text-white"}`;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      clipPath: "polygon(5px 0%,100% 0%,calc(100% - 5px) 100%,0% 100%)"
    };
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  let t11;
  if ($[6] !== locale) {
    t10 = <Flag locale={locale} />;
    t11 = <span>{locale}</span>;
    $[6] = locale;
    $[7] = t10;
    $[8] = t11;
  } else {
    t10 = $[7];
    t11 = $[8];
  }
  const t12 = `transition-transform duration-200 ${open ? "rotate-180" : ""}`;
  let t13;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <path d="M0 0h8L4 5z" fill="#e8620a" />;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  let t14;
  if ($[10] !== t12) {
    t14 = <svg width="8" height="5" viewBox="0 0 8 5" aria-hidden="true" className={t12}>{t13}</svg>;
    $[10] = t12;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  let t15;
  if ($[12] !== open || $[13] !== t10 || $[14] !== t11 || $[15] !== t14 || $[16] !== t7 || $[17] !== t8) {
    t15 = <button type="button" onClick={t6} aria-haspopup="listbox" aria-expanded={open} aria-label={t7} className={t8} style={t9}>{t10}{t11}{t14}</button>;
    $[12] = open;
    $[13] = t10;
    $[14] = t11;
    $[15] = t14;
    $[16] = t7;
    $[17] = t8;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  const t16 = `absolute right-0 top-[calc(100%+8px)] z-[2100] min-w-[150px] origin-top border border-[#e8620a]/25 bg-[#0d0a07]/95 p-1 shadow-[0_12px_40px_rgba(0,0,0,0.6)] backdrop-blur transition-all duration-200 ${open ? "pointer-events-auto scale-100 opacity-100" : "pointer-events-none scale-95 opacity-0"}`;
  let t17;
  if ($[19] !== locale || $[20] !== setLocale) {
    t17 = LOCALES.map(code => {
      const active = code === locale;
      return <li key={code}><button type="button" role="option" aria-selected={active} onClick={() => {
          setLocale(code);
          setOpen(false);
        }} className={`flex w-full items-center gap-3 px-3 py-2 text-left text-[13px] uppercase tracking-[0.14em] transition-colors duration-150 ${active ? "bg-[#e8620a]/15 text-[#e8620a]" : "text-white/65 hover:bg-white/5 hover:text-white"}`}><Flag locale={code} /><span className="flex-1">{LABELS[code]}</span>{active && <span aria-hidden="true">✦</span>}</button></li>;
    });
    $[19] = locale;
    $[20] = setLocale;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t16 || $[23] !== t17) {
    t18 = <ul role="listbox" aria-label="Choisir la langue" className={t16}>{t17}</ul>;
    $[22] = t16;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== t15 || $[26] !== t18 || $[27] !== t4) {
    t19 = <div ref={ref} translate="no" className={t4} style={t5}>{t15}{t18}</div>;
    $[25] = t15;
    $[26] = t18;
    $[27] = t4;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  return t19;
}
function _temp(o) {
  return !o;
}